




























import Vue from "vue";
import $ from "jquery";
import "../../plugins/jQueryRotate.js";
import { isLogin } from "../../common/common";
import { getAllHistory, roteJoin, roteCdkeys } from "../../common/api";
import Pixel from "@/service/pixel";
// Pixel.instance.init({
//   id: {
//     fb: CONFIG['data'].fb,
//     ga: CONFIG['data'].ga,
//   }
// });
declare var FB: any;
declare var CONFIG: any;
export default Vue.extend({
  name: "Rote",
  data() {
    return {
      text: CONFIG,
      isTrue: false //轉盤按鈕是否可點擊
    };
  },
  methods: {
    // 查看礼包
    async searchRewardBtn() {
      if (isLogin()) {
        let data: any = await roteCdkeys();
        let arr = ['5c64e20e856f3e06d004500a','5c64e26e856f3e06d004502e']
        if (data && data.code == 200) {
          if (!data.state.length) {
            Vue.prototype.$dialog.show("tip", CONFIG["tip"].giftArr_null);
            return;
          }else{
            for (let index = 0; index < data.state.length; index++) {
              if (data.state[index].cdKeys != "null") {
                if(arr.includes(data.state[index].rewardId as any)){
                  Vue.prototype.$dialog.show("tip",CONFIG["tip"].success_code +data.state[index].rewardName +"," +CONFIG["tip"].success_code_time);
                }else{
                  Vue.prototype.$dialog.show("reward", [data.state[index]]);
                }
                return;
              }
            }
          }           
        }
      } else {
        Vue.prototype.$dialog.show("tip", CONFIG["tip"].code_300, true);
      }
    },
    // 点击分享
    async fbShareBtn() {
      if (isLogin()) {
        //分享API和次数API同时回调
        FB.ui(
          {
            method: "share",
            display: "popup",
            href:
              "https://www.joygame.vn/activity/register/"
          },
          response => {
            // if(response && !response.error_message){
            //     Vue.prototype.$dialog.show(CONFIG.tip.tip22);
            // }
          }
        );
        let data: any = await roteJoin(true);
        if (data && data.code == 200) {
          // console.log(data);
        }
      } else {
        Vue.prototype.$dialog.show("tip", CONFIG["tip"].code_300, true);
      }
    },
    // 点击转盘
    async roteBtn() {
      if (isLogin()) {
        Pixel.instance.pixel("wheel");        
        let data: any = await roteJoin(false);
        if (data && data.code == 200) {
          var index = CONFIG["data"].rewardId.rotate.indexOf(data.state.rewardId) < 0 ? 3 : CONFIG["data"].rewardId.rotate.indexOf(data.state.rewardId);
          this.isTrue = true;
          $(".roteBg").rotate({
            angle: 0,
            duration: 3000,
            animateTo: 360 * 5 + (9 - index) * 40 + 20,
            callback: () => {
              this.isTrue = false;
              if (index != 3) {
                Pixel.instance.pixel("success");
                let arr = ['5c64e20e856f3e06d004500a','5c64e26e856f3e06d004502e']
                if (arr.includes(data.state.rewardId as any)) {
                  Vue.prototype.$dialog.show(
                    "tip",
                    CONFIG["tip"].success_code +
                      data.state.rewardName +
                      "," +
                      CONFIG["tip"].success_code_time
                  );
                  return;
                }
                Vue.prototype.$dialog.show("cdKeys", [data.state]);
              } else {
                Vue.prototype.$dialog.show("tip", CONFIG["tip"].join_null);
              }
            }
          });
        }else if(data && data.code == 441){
          Vue.prototype.$dialog.show("phoneNull", "(Điền SĐT lần nữa để tiện phát quà)", true);
        }
      }else {
        Vue.prototype.$dialog.show("tip", CONFIG["tip"].code_300, true);
      }
    }
  }
});
